module.exports = __webpack_public_path__ + "static/media/thirteenth_columbus_regional_hospital4.29aaa6a2.png";